// extracted by mini-css-extract-plugin
export default {"tukkukorttiWrapper":"c4D8LO9jwGiRd2n50vRQ-TukkukorttiWrapper-tukkukorttiWrapper","cardstackWrapper":"OpbF6qJ5CwKiXsMjrQNj-TukkukorttiWrapper-cardstackWrapper"};